import { ModelBase } from './base/modelbase.model';

export class AusenciaTemporaria extends ModelBase {
    id: number;
    ativo: boolean;
    dataCadastro: Date;
    dataFim: Date;
    dataInicio: Date;
    loginUsuario: string;
    loginUsuarioRecebedor: string;
    excluido: boolean;
    delegarPerfil: boolean;
    emailUsuarioRecebedor: string;
    nomeUsuario: string;
    nomeUsuarioRecebedor: string;
}
